const URL_API = "https://admin.moncongoexpress.com/api/v1/";

// const URL_API = "http://localhost/shop/api/v1/";

export default URL_API;